import { render } from "./CollaboraEditorModal.vue?vue&type=template&id=2ac0046e&scoped=true"
import script from "./CollaboraEditorModal.vue?vue&type=script&lang=js"
export * from "./CollaboraEditorModal.vue?vue&type=script&lang=js"

import "./CollaboraEditorModal.vue?vue&type=style&index=0&id=2ac0046e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac0046e"]])

export default __exports__